import React from "react";
import Navbar from "./Dashboard-Components/DashNavbar";
import "./CssFiles/dashboard.css"
const Dashboard = () => {
  
  return (
    <>
    <div className="dashboard">
      <Navbar/>
    </div>
    </>
  );
};

export default Dashboard;
